import * as actionTypes from './action-types';

export const getDefaultCourses = () =>
    ({ type: actionTypes.GET_ADMIN_DEFAULT_COURSE_REQUEST });

export const getDefaultCoursesSuccess = data =>
    ({ type: actionTypes.GET_ADMIN_DEFAULT_COURSE_SUCCESS, data });

export const getDefaultCoursesFailure = () =>
    ({ type: actionTypes.GET_ADMIN_DEFAULT_COURSE_FAILURE });

export const checkCommonTasksSuccess = assignedTasksId =>
    ({ type: actionTypes.CHECK_COMMON_TASKS_SUCCESS, assignedTasksId });

export const checkCommonTasksFailure = () =>
    ({ type: actionTypes.CHECK_COMMON_TASKS_FAILURE });

export const assignCoursesRequest = changeCourseRequests =>
    ({ type: actionTypes.ASSIGN_COURSES_REQUEST, changeCourseRequests });

export const assignCoursesSuccess = assigningCourses =>
    ({ type: actionTypes.ASSIGN_COURSES_SUCCESS, assigningCourses });

export const assignCoursesFailure = assigningCourses =>
    ({ type: actionTypes.ASSIGN_COURSES_FAILURE, assigningCourses });

export const showCourseDetails = courseId =>
    ({ type: actionTypes.SHOW_COURSE_DETAILS, courseId });

export const hideCourseDetails = () =>
    ({ type: actionTypes.HIDE_COURSE_DETAILS });

export const fetchCourseDetails = () =>
    ({ type: actionTypes.FETCH_COURSE_DETAILS_REQUEST });

export const fetchCourseDetailsSuccess = data =>
    ({ type: actionTypes.FETCH_COURSE_DETAILS_SUCCESS, courseDetails: data });

export const fetchCourseDetailsFailure = () =>
    ({ type: actionTypes.FETCH_COURSE_DETAILS_FAILURE });



// WEBPACK FOOTER //
// ./app/containers/manage-assigned-courses/actions.js